import { Checkbox, FormControlLabel } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface ReminderNotificationsSelectorProps {
    hasTime: boolean;
    reminderNotifications: string[];
    onChange: (newReminderNotifications: string[]) => void;
}

export default function ReminderNotificationsSelector(props: ReminderNotificationsSelectorProps) {
    const { t } = useTranslation();

    const timeSpan1Week = "7.00:00:00";
    const timeSpan1Day = "1.00:00:00";
    const timeSpan1Hour = "01:00:00";

    const has1WeekReminder = useMemo(
        () => props.reminderNotifications.filter(r => r === timeSpan1Week).length > 0,
        [props.reminderNotifications]
    );
    const has1DayReminder = useMemo(
        () => props.reminderNotifications.filter(r => r === timeSpan1Day).length > 0,
        [props.reminderNotifications]
    );
    const has1HourReminder = useMemo(
        () => props.reminderNotifications.filter(r => r === timeSpan1Hour).length > 0,
        [props.reminderNotifications]
    );

    const handleOnChange = (checked: boolean, timeSpan: string) => {
        const reminderWithRemovedTimeSpan = props.reminderNotifications.filter(r => r !== timeSpan);

        if (checked) {
            props.onChange([...reminderWithRemovedTimeSpan, timeSpan]);
        }
        else {
            props.onChange(reminderWithRemovedTimeSpan);
        }
    }

    return <>
        <FormControlLabel
            label={t("serviceModulesPage.calendarPage.notification1Week")}
            control={<Checkbox
                checked={has1WeekReminder}
                onChange={(v) => handleOnChange(v.target.checked, timeSpan1Week)
                } />}
        />
        <FormControlLabel
            label={t("serviceModulesPage.calendarPage.notification1Day")}
            control={<Checkbox
                checked={has1DayReminder}
                onChange={(v) => handleOnChange(v.target.checked, timeSpan1Day)
                } />}
        />
        {
            props.hasTime && <FormControlLabel
                label={t("serviceModulesPage.calendarPage.notification1Hour")}
                control={<Checkbox
                    checked={has1HourReminder}
                    onChange={(v) => handleOnChange(v.target.checked, timeSpan1Hour)
                    } />}
            />
        }
    </>
}